import { MetaDispatcher as SourceMetaDispatcher } from 'SourceStore/Meta/Meta.dispatcher';
import { appendWithStoreCode, getQueryParam } from 'Util/Url';

/** @namespace Scandipwa/Store/Meta/Dispatcher */
export class MetaDispatcher extends SourceMetaDispatcher {
    _getProductMeta(product) {
        const {
            name,
            meta_title,
            meta_keyword,
            canonical_url,
            meta_description,
            variants,
            thumbnail,
            description: {
                html: productsDescription = ''
            } = {}
        } = product;

        // replaced html tags with space so there would be a space after heading
        const productsDescriptionString = productsDescription.replace(/<[^>]*>/g, ' ');
        const sentences = productsDescriptionString.split('.');
        const firstTwoSentencesArray = sentences.length > 2 ? sentences.slice(0, 2) : sentences.slice(0, 1);
        // replaced 2 spaces with 1 in case if there are multiple html tags in a row and removed space before the string
        const firstTwoSentences = firstTwoSentencesArray.join('.').replace('  ', ' ').trim();
        const hasMediaGallery = variants && variants[0] && variants[0].media_gallery_entries;

        return {
            description: meta_description || firstTwoSentences,
            keywords: meta_keyword,
            title: meta_title || name,
            // eslint-disable-next-line no-nested-ternary
            og_image: hasMediaGallery
                ? variants[0].media_gallery_entries[0].base.url : (thumbnail ? thumbnail.url : ''),
            canonical_url: `${window.location.origin}${appendWithStoreCode(canonical_url)}`
        };
    }

    getPageParam(appendUrl) {
        const page = getQueryParam('page', window.location);

        const pageValue = (page > 1 || page) ? page : null;

        if (pageValue && (appendUrl === '' || !appendUrl)) {
            return (`?page=${pageValue}`);
        }

        if (pageValue && appendUrl !== '') {
            return (`&page=${pageValue}`);
        }

        return '';
    }

    _getCategoryMeta(category) {
        const {
            description, name, canonical_url,
            meta_title, meta_keywords, meta_description, image,
            meta_robots = 'follow, index'
        } = category;

        const customFiltersValue = getQueryParam('customFilters', window.location)
            ? getQueryParam('customFilters', window.location) : '';

        const customFiltersString = (
            (
                customFiltersValue.includes('refinement_color') && !customFiltersValue.includes(',')
                && !customFiltersValue.includes(';')
            ) || (
                customFiltersValue.includes('size') && !customFiltersValue.includes(',')
                && !customFiltersValue.includes(';')
            )
        ) ? `?customFilters=${customFiltersValue}` : '';

        return {
            description: meta_description || description,
            title: meta_title || name,
            keywords: meta_keywords,
            og_image: image ? image.url : '',
            canonical_url: `${window.location.origin}${appendWithStoreCode(canonical_url)}${customFiltersString}`
                + `${this.getPageParam(customFiltersString)}`,
            robots: meta_robots
        };
    }
}

export default new MetaDispatcher();
